import { render, staticRenderFns } from "./SelectionCardOosOverlay.vue?vue&type=template&id=34dc5db0"
import script from "./SelectionCardOosOverlay.vue?vue&type=script&lang=js"
export * from "./SelectionCardOosOverlay.vue?vue&type=script&lang=js"
import style0 from "./SelectionCardOosOverlay.vue?vue&type=style&index=0&id=34dc5db0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports